import React from 'react';

export default function BlockSelectionOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 rounded"
      style={{
        border: '1px solid rgba(34, 211, 238, 0.9)',
        boxShadow: '0 0 0 1px rgba(34, 211, 238, 0.35) inset',
      }}
    />
  );
}

